var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotebookSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14594",
    "data-name": "Group 14594",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "button_10_12_",
    "data-name": "button [10 12]",
    width: 32,
    height: 32,
    rx: 4,
    transform: "translate(2 2)",
    fill: "#ff9200"
  }), /*#__PURE__*/React.createElement("g", {
    id: "notebook--reference",
    transform: "translate(7.36 7.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11790",
    "data-name": "Path 11790",
    d: "M3.375,20v1.375H5.84L2,25.215l.972.972,3.84-3.84v2.465H8.188V20Z",
    transform: "translate(-0.625 -6.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5209",
    "data-name": "Rectangle 5209",
    width: 4.812,
    height: 1.375,
    transform: "translate(13.063 6.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5210",
    "data-name": "Rectangle 5210",
    width: 4.812,
    height: 1.375,
    transform: "translate(13.063 10.313)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5211",
    "data-name": "Rectangle 5211",
    width: 4.812,
    height: 1.375,
    transform: "translate(13.063 13.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11791",
    "data-name": "Path 11791",
    d: "M19.875,5H3.375A1.376,1.376,0,0,0,2,6.375V13.25H3.375V6.375h7.563v13.75h8.938A1.376,1.376,0,0,0,21.25,18.75V6.375A1.376,1.376,0,0,0,19.875,5ZM12.313,18.75V6.375h7.563V18.75Z",
    transform: "translate(-0.625 -1.563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "<Transparent Rectangle>",
    width: 22,
    height: 22,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebookSelected);
export default __webpack_public_path__ + "static/media/notebook-selected.a2e194daa25e84fd2af700d2988d4d1a.svg";
export { ForwardRef as ReactComponent };